export var isNil = function isNil(value) {
  return value === null || value === undefined;
};